import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { DevExtremeModule } from 'devextreme-angular';
import { ChartsModule } from 'ng2-charts';
import { DpDatePickerModule } from 'ng2-jalali-date-picker';
import { ByteConvertsPipe } from '../../pipes/byte-converts.pipe';
import { BytesPipe } from '../../pipes/bytes.pipe';
import { DateformaterPipe } from '../../pipes/dateformater.pipe';
import { FilterPipe } from '../../pipes/filter.pipe';
import { GenderPipe } from '../../pipes/gender.pipe';
import { GetRemainingDaysPipe } from '../../pipes/get-remaining-days.pipe';
import { GigPipe } from '../../pipes/gig.pipe';
import { InvoiceStatusPipe } from '../../pipes/invoice-status.pipe';
import { InvoiceTypePipe } from '../../pipes/invoice-type.pipe';
import { JsonToStringPipe } from '../../pipes/json-to-string.pipe';
import { KeysPipe } from '../../pipes/keys.pipe';
import { KiloBytePipe } from '../../pipes/kilo-byte.pipe';
import { MacPipe } from '../../pipes/mac.pipe';
import { MegaBytePipe } from '../../pipes/mega-byte.pipe';
import { MinuteToTimeStructuredPipe } from '../../pipes/minute-to-time-structured.pipe';
import { MoneyPipe } from '../../pipes/money.pipe';
import { RelativeTimePipe } from '../../pipes/relative-time.pipe';
import { SecondToTimeStructuredPipe } from '../../pipes/second-to-time-structured.pipe';
import { SecondsToTimePipe } from '../../pipes/seconds-to-time.pipe';
import { SortPipe } from '../../pipes/sort.pipe';
import { TimeDiffPipe } from '../../pipes/time-diff.pipe';
import { TobpsPipe } from '../../pipes/tobps.pipe';
import { TypeFilterPipe } from '../../pipes/type-filter.pipe';
import { InvoiceDraftListComponent } from '../finance/invoice-draft-list/invoice-draft-list.component';
import { InvoiceFormComponent } from '../finance/invoice-form/invoice-form.component';
import { InvoiceListComponent } from '../finance/invoice-list/invoice-list.component';
import { InvoiceLogComponent } from '../finance/invoice-log/invoice-log.component';
import { InvoiceUserListComponent } from '../finance/invoice-user-list/invoice-user-list.component';
import { TransactionAccountListComponent } from '../finance/transaction-account-list/transaction-account-list.component';
import { AccountFormComponent } from '../general/account-form/account-form.component';
import { AccountLegalFormComponent } from '../general/account-legal-form/account-legal-form.component';
import { AccountNaturalFormComponent } from '../general/account-natural-form/account-natural-form.component';
import { ContactFromComponent } from '../general/contact-from/contact-from.component';
import { ContactListComponent } from '../general/contact-list/contact-list.component';
import { WorkLogListComponent } from '../general/work-log-list/work-log-list.component';
import { IssueFormComponent } from '../home/issue-form/issue-form.component';
import { FibermapComponent } from '../sales/fibermap/fibermap.component';
import { WirelessmapComponent } from '../sales/wirelessmap/wirelessmap.component';
import { DedicateLocationComponent } from '../sales/dedicate-location/dedicate-location.component';
import { DedicatePreinvoiceComponent } from '../sales/dedicate-preinvoice/dedicate-preinvoice.component';
import { AdslCreateComponent } from '../sales/adsl-create/adsl-create.component';
import { AdslUserlistComponent } from '../sales/adsl-userlist/adsl-userlist.component';
import { BasketComponent } from '../sales/basket/basket.component';
import { DedicateCreateComponent } from '../sales/dedicate-create/dedicate-create.component';
import { DedicateUserListComponent } from '../sales/dedicate-user-list/dedicate-user-list.component';
import { TdlteCreateComponent } from '../sales/tdlte-create/tdlte-create.component';
import { TdlteUserListComponent } from '../sales/tdlte-user-list/tdlte-user-list.component';
import { UserListComponent } from '../sales/user-list/user-list.component';
import { VoipCreateComponent } from '../sales/voip-create/voip-create.component';
import { VoipUserListComponent } from '../sales/voip-user-list/voip-user-list.component';
import { AuditTrailComponent } from '../software/audit-trail/audit-trail.component';
import { NodeListComponent } from '../technical/node-list/node-list.component';
import { PingLogComponent } from '../technical/ping-log/ping-log.component';
import { SpeedtestComponent } from '../technical/speedtest/speedtest.component';
import { FormComponent } from './form/form.component';
import { ListComponent } from './list/list.component';
import { ObjectViewerComponent } from './object-viewer/object-viewer.component';
import { SmsAccountListComponent } from './sms-account-list/sms-account-list.component';
import { AudioPlayerComponent } from './audio-player/audio-player.component';
import { WirelessUserListComponent } from '../sales/wireless-user-list/wireless-user-list.component';
import { WirelessCreateComponent } from '../sales/wireless-create/wireless-create.component';
import { ServerUserListComponent } from '../sales/server-user-list/server-user-list.component';
import { ServerCreateComponent } from '../sales/server-create/server-create.component';
import { FiberUserListComponent } from '../sales/fiber-user-list/fiber-user-list.component';
import { FiberCreateComponent } from '../sales/fiber-create/fiber-create.component';


@NgModule({
  declarations: [
    DateformaterPipe,
    SecondsToTimePipe,
    GigPipe,
    MegaBytePipe,
    KiloBytePipe,
    ByteConvertsPipe,
    MoneyPipe,
    SortPipe,
    FilterPipe,
    SecondToTimeStructuredPipe,
    MinuteToTimeStructuredPipe,
    TimeDiffPipe,
    GenderPipe,
    InvoiceTypePipe,
    InvoiceStatusPipe,
    KeysPipe,
    TypeFilterPipe,
    JsonToStringPipe,
    BytesPipe,
    GetRemainingDaysPipe,
    MacPipe,
    TobpsPipe,
    RelativeTimePipe,
    AccountFormComponent,
    AccountNaturalFormComponent,
    AccountLegalFormComponent,
    ContactListComponent,
    InvoiceListComponent,
    InvoiceUserListComponent,
    InvoiceDraftListComponent,
    InvoiceLogComponent,
    InvoiceFormComponent,
    AuditTrailComponent,
    IssueFormComponent,
    FibermapComponent,
    WirelessmapComponent,
    DedicateLocationComponent,
    DedicatePreinvoiceComponent,
    FormComponent,
    ContactFromComponent,
    PingLogComponent,
    ObjectViewerComponent,
    NodeListComponent,
    SpeedtestComponent,
    ListComponent,
    TransactionAccountListComponent,
    WirelessUserListComponent,
    WirelessCreateComponent,
    TdlteUserListComponent,
    TdlteCreateComponent,
    DedicateUserListComponent,
    DedicateCreateComponent,
    ServerUserListComponent,
    ServerCreateComponent,
    FiberUserListComponent,
    FiberCreateComponent,
    AdslUserlistComponent,
    AdslCreateComponent,
    VoipUserListComponent,
    VoipCreateComponent,
    BasketComponent,
    SmsAccountListComponent,
    UserListComponent,
    WorkLogListComponent,
    AudioPlayerComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule,
    DpDatePickerModule,
    FormsModule,
    DevExtremeModule,
    NgbModule,

    ChartsModule,
    LeafletModule.forRoot(),
  ],
  exports: [
    DateformaterPipe,
    SecondsToTimePipe,
    GigPipe,
    MegaBytePipe,
    KiloBytePipe,
    ByteConvertsPipe,
    MoneyPipe,
    SortPipe,
    FilterPipe,
    SecondToTimeStructuredPipe,
    MinuteToTimeStructuredPipe,
    TimeDiffPipe,
    GenderPipe,
    InvoiceTypePipe,
    InvoiceStatusPipe,
    KeysPipe,
    TypeFilterPipe,
    JsonToStringPipe,
    BytesPipe,
    GetRemainingDaysPipe,
    MacPipe,
    TobpsPipe,
    RelativeTimePipe,
    AccountNaturalFormComponent,
    AccountLegalFormComponent,
    IssueFormComponent,
    FibermapComponent,
    WirelessmapComponent,
    DedicateLocationComponent,
    DedicatePreinvoiceComponent,
    FormComponent,
    ContactFromComponent,
    PingLogComponent,
    ObjectViewerComponent,
    NodeListComponent,
    SpeedtestComponent,
    InvoiceListComponent,
    InvoiceDraftListComponent,
    InvoiceLogComponent,
    InvoiceFormComponent,
    InvoiceUserListComponent,
    TransactionAccountListComponent,
    WirelessUserListComponent,
    WirelessCreateComponent,
    TdlteUserListComponent,
    TdlteCreateComponent,
    DedicateUserListComponent,
    DedicateCreateComponent,
    AdslUserlistComponent,
    AdslCreateComponent,
    BasketComponent,
    SmsAccountListComponent,
    UserListComponent,
    WorkLogListComponent,
    ServerUserListComponent,
    ServerCreateComponent,
    FiberUserListComponent,
    FiberCreateComponent,
  ]
})
export class SharedModule { }
